import { useWebhookDeleteIntegrationWebhookDeleteDeleteMutation } from '@shared/api';
import { useState } from 'react';

export const useDeleteIntegration = (onError?: () => void) => {
  const [deleteIntegrationMutation, { isLoading: isDeleteIntegrationLoading }] =
    useWebhookDeleteIntegrationWebhookDeleteDeleteMutation();
  const [loadingIntegrationId, setLoadingIntegrationId] = useState<number | null>(null);

  const deleteIntegration = async (webhookIntegrationId: number) => {
    setLoadingIntegrationId(webhookIntegrationId);

    try {
      await deleteIntegrationMutation({
        webhookIntegrationId,
      }).unwrap();
    } catch {
      onError?.();
      throw new Error();
    } finally {
      setLoadingIntegrationId(null);
    }
  };

  return {
    deleteIntegration,
    isDeleteIntegrationLoading,
    loadingIntegrationId,
  };
};
